export default {
    base_url: 'https://www.themealdb.com/api/json/v1/1'
};
